<template>
    <div>
        <div class="subheading">
            <template >Ingresa al panel de administración</template>

        </div>
        <v-form @submit.prevent="login()">

            <v-text-field
                    v-model="usuario.email"
                    light="light"
                    prepend-icon="email"
                    label="Correo electrónico"
                    type="email"
                    required
            />
            <v-text-field
                    v-model="usuario.password"
                    light="light"
                    prepend-icon="lock"
                    label="Contraseña"
                    type="password"
                    required
            />

            <v-btn block="block" type="submit" color="primary">Ingresar</v-btn>


        </v-form>
        <v-snackbar
                v-model="snackbar"
                color="error"
                :timeout="8000"
                class="text--white"
        >
            {{ text }}
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data: () =>({
            usuario:{
                email:'',
                password:''
            },
            snackbar:false,
            text:''
        }),
        methods:{
            login(){
                this.$store.dispatch('signUserIn', {
                    email: this.usuario.email,
                    password: this.usuario.password
                })
            }
        },
        computed:{
            user () {
                return this.$store.getters.user
            },
            error () {
                return this.$store.getters.error
            }

        },
        watch: {
            user (value) {
                if (value !== null && value !== undefined) {
                    // Antes se iba siempre al dashboard: un perfil que no lo tiene
                    // habilitado entraba y el guard lo rebotaba enseguida. Se va
                    // directo a la primera pantalla que si tiene.
                    const destino = this.$store.getters.rutaInicial;
                    if (!destino || destino === '/auth') return;
                    // El guard puede abortar la navegacion; sin el catch queda una
                    // promesa rechazada suelta en la consola.
                    this.$router.push(destino).catch(() => {})
                }
            },
            error: {
                immediate: true,
                handler ( value ){
                    if (value !== null && value !== undefined) {
                        this.text = value.message || value;
                        this.snackbar = true
                    } else {
                        // Al limpiar el error se cierra el cartel: si no, quedaba
                        // el mensaje viejo en pantalla durante el reintento.
                        this.snackbar = false
                    }
                }
            }
        },
    }
</script>

<style lang="sass" scoped>

</style>
